import { cn } from '@/styles/theme';

export const trustWalletSvg = (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 2500 2500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('text-ock-foreground')}
    aria-labelledby="trustWallet"
  >
    <title id="trustWalletTitle">Trust Wallet Logo</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M84.1,426.3C-1,593.5-1,812.7-1,1250c0,438.4,0,656.5,85.1,823.7c75.1,147.1,195.2,266.2,341.3,341.3   C592.5,2500,811.7,2500,1249,2500c438.4,0,656.5,0,823.7-85.1c147.1-75.1,266.2-195.2,341.3-341.3   c85.1-167.1,85.1-386.3,85.1-823.7c0-438.4,0-656.5-85.1-823.7c-75.1-147.1-195.2-266.2-341.3-341.3C1905.5,0,1686.3,0,1249,0   C810.6,0,592.5,0,425.3,85.1C278.2,160.1,159.1,280.2,84.1,426.3z M1874.5,674.5c22,0,43,9,58,24c15,16,24,37,23,58   c-4,233.2-13,411.3-30,552.4c-16,141.1-41,246.2-78.1,330.3c-25,57-56,104.1-92.1,143.1c-49,53-105.1,91.1-166.1,127.1   c-26,16-53,31-82.1,47c-61,34-127.1,72.1-203.2,123.1c-27,18-63.1,18-90.1,0c-77.1-51-144.1-89.1-205.2-124.1c-14-8-27-15-40-23   c-71.1-41-136.1-81.1-192.2-138.1c-38-38-70.1-83.1-96.1-138.1c-35-73.1-59-161.1-77.1-274.2c-23-152.1-35-351.3-39-627.5   c0-21,8-43,23-58s36-24,58-24h34c104.1,0,332.3-10,530.4-164.1c29-23,70.1-23,100.1,0c198.2,154.1,426.3,164.1,530.4,164.1h34   V674.5z M1692.4,1588.3c25-52,47-125.1,63.1-229.2c19-124.1,31-293.2,36-523.4c-122.1-4-331.3-27-531.4-161.1   c-200.2,134.1-409.3,157.1-530.4,161.1c4,190.2,13,338.3,27,454.4c16,132.1,38,221.2,66.1,284.2c18,42,39,72.1,63.1,98.1   c32,36,73.1,65.1,129.1,98.1c23,14,49,28,77.1,44c50,28,106.1,60,170.1,100.1c62-40,118.1-71.1,167.1-99.1c15-8,29-16,42-24   c69.1-39,120.1-72.1,157.1-111.1c25-26,46-55,65.1-94.1L1692.4,1588.3z"
      fill="#3375BB"
    />
  </svg>
);
